export enum MfaModalState {
  NoModal = 0,
  Setup2Fa = 1,
  ScanQrCode = 2,
  Enter2FaCode = 3,
  Enabled2Fa = 4,
  Reset2Fa = 5,
  PromptAlertModal = 6,
  ContinueLogin = 7,
  NotificationSent = 8,
  OtherMethod = 9,
}

export enum BiometricPoll {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum FACTORS {
  TOTP = 'totp',
  BIOMETRIC = 'biometric',
}

export enum MaxApiLimit {
  MAX_API_LIMIT = 'MFA-0009',
}

export enum VerifyToken {
  INVALID_AUTH_CODE = 'MFA-0001',
  INVALID_STATE_TOKEN = 'MFA-0002',
  INVALID_ACCESS_TOKEN = 'MFA-0003',
}
